import TypeToReducer from 'type-to-reducer';

import { TOGGLE_MENU_COLLAPSED } from 'secured/constants';

const initialState = {
  menu: {
    isCollapsedConfiguration: true,
    isCollapsedControlPanel: true,
    isCollapsedReports: true,
  },
};

const reducers = {
  [TOGGLE_MENU_COLLAPSED]: (state, { payload: { menu, collapsed } }) => {
    switch (menu) {
      case 'reports':
        return { ...state, menu: { ...state.menu, isCollapsedReports: collapsed } };
      case 'control_panel':
        return { ...state, menu: { ...state.menu, isCollapsedControlPanel: collapsed } };
      case 'configuration':
        return { ...state, menu: { ...state.menu, isCollapsedConfiguration: collapsed } };
      default:
        return state;
    }
  },
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/reducers/secured_reducers.js